import { MEIO_JULGAMENTO_PROCESSO } from '@/dominio/MeioJulgamentoProcesso';
import { SITUACAO_ACORDAO } from '@/dominio/SituacaoAcordao';
import { SITUACAO_ALTERACAO_MINUTA } from '@/dominio/SituacaoAlteracaoMinuta';
import { SITUACAO_ANALISE } from '@/dominio/SituacaoAnalise';
import SituacaoImpedimentosProcesso, { SITUACAO_IMPEDIMENTOS_PROCESSO } from '@/dominio/SituacaoImpedimentosProcesso';
import SituacaoPublicacaoPauta, { SITUACAO_PUBLICACAO_PAUTA } from '@/dominio/SituacaoPublicacaoPauta';
import TipoRemessaJulgamentoProcesso, {
    TIPO_REMESSA_JULGAMENTO_PROCESSO
} from '@/dominio/TipoRemessaJulgamentoProcesso';
import IconeMagistrado from '@/img/IconeMagistrado';
import {
    faAngleDoubleRight,
    faFileContract,
    faFileExport,
    faFileImport,
    faFileSignature,
    faListOl,
    faSolarPanel,
    faSortAlphaDown,
    faSpinner
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    ContentPasteGo,
    PlaylistAddCheck,
    Publish,
    PublishedWithChanges,
    Sensors,
    SensorsOff,
    SimCardAlert,
    SwipeRightAlt,
    Unpublished
} from '@mui/icons-material';
import Add from '@mui/icons-material/Add';
import AddBox from '@mui/icons-material/AddBox';
import AirPlay from '@mui/icons-material/Airplay';
import Announcement from '@mui/icons-material/Announcement';
import Assignment from '@mui/icons-material/Assignment';
import NaoLiberado from '@mui/icons-material/Block';
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import IconeCalendario from '@mui/icons-material/CalendarMonth';
import CallMade from '@mui/icons-material/CallMade';
import Cancel from '@mui/icons-material/Cancel';
import IconeApregoar from '@mui/icons-material/Cast';
import IconeApregoado from '@mui/icons-material/CastConnected';
import CheckCircleRounded from '@mui/icons-material/CheckCircleRounded';
import Difference from '@mui/icons-material/Difference';
import CorreJunto from '@mui/icons-material/DirectionsRun';
import EditNoteIcon from '@mui/icons-material/EditNote';
import PeticoesPendentes from '@mui/icons-material/Filter9Plus';
import FilterList from '@mui/icons-material/FilterList';
import FindInPage from '@mui/icons-material/FindInPage';
import ForkRight from '@mui/icons-material/ForkRight';
import Gavel from '@mui/icons-material/Gavel';
import Group from '@mui/icons-material/Group';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import Help from '@mui/icons-material/Help';
import Home from '@mui/icons-material/Home';
import VistaMesa from '@mui/icons-material/LocalLibrary';
import SegredoJustica from '@mui/icons-material/Lock';
import MeetingRoom from '@mui/icons-material/MeetingRoom';
import NoMeetingRoom from '@mui/icons-material/NoMeetingRoom';
import Anotacoes from '@mui/icons-material/Notes';
import Impedimento from '@mui/icons-material/PanTool';
import PlayIcon from '@mui/icons-material/PlayCircleFilled';
import Print from '@mui/icons-material/Print';
import SustentacaoOral from '@mui/icons-material/RecordVoiceOver';
import Refresh from '@mui/icons-material/Refresh';
import VistaRegimental from '@mui/icons-material/RemoveRedEye';
import Restore from '@mui/icons-material/Restore';
import SnoozeIcon from '@mui/icons-material/Snooze';
import SquareIcon from '@mui/icons-material/Square';
import Star from '@mui/icons-material/Star';
import StopIcon from '@mui/icons-material/Stop';
import TaskIcon from '@mui/icons-material/Task';
import ThumbDown from '@mui/icons-material/ThumbDown';
import Timer from '@mui/icons-material/Timer';
import { Avatar, Box, Dialog, IconButton, List, ListItem, Stack, Tooltip, Typography } from '@mui/material';
import { green, grey, lightGreen, orange, red, yellow } from '@mui/material/colors';
import { action, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import IconeAcordao from '../img/IconeAcordao';
import IconeJulgarPlanilha from '../img/IconeJulgarPlanilha';
import IconeJulgarAlterado from '../img/gavelA.svg';
import IconeJulgar from '../img/gavelJ.svg';
import IconeNaoJulgado from '../img/gavelN.svg';
import IconeJulgarObervacao from '../img/gavelO.svg';
import IconeVotoRevogado from './IconeVotoRevogado';
import OrdemPreSessao from './OrdemPreSessao';
import ReactComponent from './ReactComponent';
import IconeDetalhePregao from './icones/IconeDetalhePregao';
import IconeSubstituirParticipante from './sessao/IconeSubstituirParticipante';
import StatusMinuta from './sessao/StatusMinuta';
import IconeAdvogado from './sessao/icones/IconeAdvogado';
import IconeAdvogadoParticipacaoVirtual from './sessao/icones/IconeAdvogadoParticipacaoVirtual';
import IconeAdvogadoPedidoDestaque from './sessao/icones/IconeAdvogadoPedidoDestaque';
import IconeAdvogadoPreferencia from './sessao/icones/IconeAdvogadoPreferencia';
import IconeAdvogadoSustentacaoOralEletronica from './sessao/icones/IconeAdvogadoSustentacaoOralEletronica';
import IconeAdvogadoSustentacaoOralTelepresencial from './sessao/icones/IconeAdvogadoSustentacaoOralTelepresencial';
import IconeLimpar from './sessao/icones/IconeLimpar';
import IconeTipoJulgamento from './sessao/icones/IconeTipoJulgamento';

class Legenda extends ReactComponent {
    open = false;
    expand = false;

    abrirInfo = () => {
        this.open = true;
    };

    fecharInfo = () => {
        this.open = false;
    };

    handleExpandClick = () => {
        this.expand = !this.expand;
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            open: observable,
            expand: observable,
            abrirInfo: action,
            fecharInfo: action,
            handleExpandClick: action
        });
    }

    /**
     * @returns {Array.<JSX.Element>}
     */
    carregarItensSituacaoPublicacaoPauta() {
        const opcoes = [];
        const situacoes = Object.values(SITUACAO_PUBLICACAO_PAUTA);

        let index = 0;
        for (const situacao of situacoes) {
            const legendaSituacao = (
                <Stack
                    direction="row"
                    sx={{ mt: 1 }}
                >
                    {SituacaoPublicacaoPauta.getIcone(situacao.id)}
                    <Typography sx={{ ml: 3 }}>
                        {situacao.descricao.concat(++index < situacoes.length ? ';' : '.')}
                    </Typography>
                </Stack>
            );

            opcoes.push(legendaSituacao);
        }

        return opcoes;
    }

    /**
     * @returns {Array.<JSX.Element>}
     */
    carregarItensRemessaJulgamento() {
        const opcoes = [];
        const tiposRemessa = Object.values(TIPO_REMESSA_JULGAMENTO_PROCESSO);

        let index = 0;
        for (const tipoRemessa of tiposRemessa) {
            const legenda = (
                <Stack
                    direction="row"
                    sx={{ mt: 1 }}
                >
                    {TipoRemessaJulgamentoProcesso.getIcone(tipoRemessa.id)}
                    <Typography sx={{ ml: 3 }}>
                        {tipoRemessa.descricao.concat(++index < tiposRemessa.length ? ';' : '.')}
                    </Typography>
                </Stack>
            );

            opcoes.push(legenda);
        }

        return opcoes;
    }

    render() {
        /**
         * @type {Array.<Object>}
         */
        const listaIcones = [
            {
                icone: <SnoozeIcon />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Sessão de julgamento com status &quot;AGUARDANDO SESSÃO DE JULGAMENTO&quot;.
                    </Typography>
                ]
            },
            {
                icone: <MeetingRoom />,
                descricao: [
                    <Typography key={this.nextKey}>Sessão de julgamento com status &quot;ABERTA&quot;.</Typography>
                ]
            },
            {
                icone: <PlayIcon />,
                descricao: [
                    <Typography key={this.nextKey}>Sessão de julgamento com status &quot;INICIADA&quot;.</Typography>
                ]
            },
            {
                icone: <StopIcon />,
                descricao: [
                    <Typography key={this.nextKey}>Sessão de julgamento com status &quot;ENCERRADA&quot;.</Typography>
                ]
            },
            {
                icone: <NoMeetingRoom />,
                descricao: [
                    <Typography key={this.nextKey}>Sessão de julgamento com status &quot;FECHADA&quot;.</Typography>
                ]
            },
            {
                icone: <AirPlay />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Sessão de julgamento com status &quot;PLENÁRIO VIRTUAL&quot;.
                    </Typography>
                ]
            },
            {
                habilitado: this.isComponenteHabilitado('Calendario'),
                icone: <IconeCalendario />,
                descricao: [
                    <Typography key={this.nextKey}>Calendário de pautas/sessões.</Typography>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <SquareIcon style={{ color: 'orange' }} />
                        <Typography sx={{ ml: 3 }}>Pauta não publicada;</Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <SquareIcon style={{ color: 'blue' }} />
                        <Typography sx={{ ml: 3 }}>Pauta aberta;</Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <SquareIcon style={{ color: 'green' }} />
                        <Typography sx={{ ml: 3 }}>Pauta publicada.</Typography>
                    </Box>
                ]
            },
            {
                icone: <FindInPage />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Exibe as pendências dos processos da sessão, tais como: apreciação, envio de informações ao PJe,
                        assinatura de certidões e acórdãos etc.
                    </Typography>
                ]
            },
            {
                icone: <AddBox />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Viabiliza a inclusão de um processo na sessão de julgamento.
                    </Typography>
                ]
            },
            {
                icone: <Refresh />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Viabiliza o recarregamento de todas as informações da sessão de julgamento.
                    </Typography>
                ]
            },
            {
                icone: <Group />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Viabiliza o controle de presença e modo de participação dos advogados na sessão de julgamento.
                    </Typography>
                ]
            },
            {
                icone: <Print />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Viabiliza a impressão da lista de preferências da sessão.
                    </Typography>
                ]
            },
            {
                icone: (
                    <FontAwesomeIcon
                        icon={faListOl}
                        style={{ width: '24px', height: '24px' }}
                    />
                ),
                descricao: [
                    <Typography key={this.nextKey}>
                        Viabiliza o fechamento e a ordenação das inscrições de advogados (preferência/sustentação) na
                        sessão de julgamento.
                    </Typography>
                ]
            },
            {
                icone: (
                    <FontAwesomeIcon
                        icon={faFileContract}
                        style={{ width: '24px', height: '24px' }}
                    />
                ),
                descricao: [
                    <Typography key={this.nextKey}>Viabiliza a geração da ata da sessão de julgamento.</Typography>
                ]
            },
            {
                icone: <IconeMagistrado sx={{ color: 'black' }} />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Viabiliza alterar a composição da sessão de julgamento (magistrados).
                    </Typography>
                ]
            },
            {
                icone: <IconeSubstituirParticipante />,
                descricao: [
                    <Typography key={this.nextKey}>Viabiliza alterar o representante do Ministério Público.</Typography>
                ]
            },
            {
                icone: <Timer />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Viabiliza controlar o tempo de sustentação oral. A informação é exibida aos magistrados por meio
                        do Plenário Eletrônico.
                    </Typography>
                ]
            },
            {
                icone: <IconeApregoar />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Viabiliza apregoar processo ou planilha. É possível apregoar apenas se a sessão estiver
                        iniciada.
                    </Typography>
                ]
            },
            {
                icone: <IconeApregoado />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Na listagem de processos, indica que o processo está apregoado ou, na barra de ferramentas da
                        listagem, que há uma planilha apregoada.
                    </Typography>
                ]
            },
            {
                icone: <IconeDetalhePregao apregoado={false} />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Viabiliza apregoar processo e exibir detalhes do processo apregoado. É possível apregoar apenas
                        se a sessão estiver iniciada.
                    </Typography>
                ]
            },
            {
                icone: <IconeDetalhePregao apregoado={true} />,
                descricao: [<Typography key={this.nextKey}>Indica que o processo está apregoado.</Typography>]
            },
            {
                icone: <IconeJulgarPlanilha />,
                descricao: [<Typography key={this.nextKey}>Julgar planilha de processos de um magistrado.</Typography>]
            },
            {
                icone: <Gavel />,
                descricao: [<Typography key={this.nextKey}>Apreciar processos em lote.</Typography>]
            },
            {
                icone: <Assignment />,
                descricao: [<Typography key={this.nextKey}>Gerar certidões de julgamento em lote.</Typography>]
            },
            {
                icone: <SwipeRightAlt />,
                descricao: [<Typography key={this.nextKey}>Registrar movimentos/decisões em lote.</Typography>]
            },
            {
                icone: <EditNoteIcon />,
                descricao: [<Typography key={this.nextKey}>Alterar rascunho da certidão em lote.</Typography>]
            },
            {
                icone: <ContentPasteGo />,
                descricao: [<Typography key={this.nextKey}>Relatório dos processos.</Typography>]
            },
            {
                icone: (
                    <FontAwesomeIcon
                        icon={faFileSignature}
                        style={{ width: '24px', height: '24px' }}
                    />
                ),
                descricao: [
                    <Typography key={this.nextKey}>
                        Assinar certidões em lote. Exibido apenas quando a opção para listar os processos apreciados
                        estiver selecionada.
                    </Typography>
                ]
            },
            {
                icone: <CallMade />,
                descricao: [
                    <Typography key={this.nextKey}>Enviar as informações dos processos em lote para o PJe.</Typography>
                ]
            },
            {
                icone: (
                    <FontAwesomeIcon
                        icon={faSpinner}
                        style={{ width: '22px', height: '22px', marginTop: '4px' }}
                    />
                ),
                descricao: [<Typography key={this.nextKey}>Operações em lote realizadas em segundo plano.</Typography>]
            },
            {
                icone: <Home />,
                descricao: [<Typography key={this.nextKey}>Ir para o início da lista de processos.</Typography>]
            },
            {
                icone: (
                    <FontAwesomeIcon
                        icon={faSortAlphaDown}
                        style={{ width: '22px', height: '22px', marginTop: '4px' }}
                    />
                ),
                descricao: [
                    <Typography key={this.nextKey}>
                        Atualizar ordem dos processos na listagem conforme padrão do sistema.
                    </Typography>
                ]
            },
            {
                icone: <FilterList />,
                descricao: [<Typography key={this.nextKey}>Viabiliza filtrar.</Typography>]
            },
            {
                icone: <FilterList sx={{ color: red[500], fill: red[500] }} />,
                descricao: [<Typography key={this.nextKey}>Indica que há filtros ativos.</Typography>]
            },
            {
                icone: <GroupAddIcon />,
                descricao: [<Typography key={this.nextKey}>Filtro por mais de uma parte autora.</Typography>]
            },
            {
                icone: (
                    <FontAwesomeIcon
                        icon={faFileExport}
                        style={{ cursor: 'pointer', width: '22px', height: '22px' }}
                    />
                ),
                descricao: [<Typography key={this.nextKey}>Exportar lista de processos para um arquivo.</Typography>]
            },
            {
                icone: (
                    <FontAwesomeIcon
                        icon={faFileImport}
                        style={{ cursor: 'pointer', width: '22px', height: '22px' }}
                    />
                ),
                descricao: [<Typography key={this.nextKey}>Importar lista de processos de um arquivo.</Typography>]
            },
            {
                icone: (
                    <FontAwesomeIcon
                        icon={faSolarPanel}
                        style={{ cursor: 'pointer', width: '22px', height: '22px' }}
                    />
                ),
                descricao: [
                    <Typography key={this.nextKey}>Exportar painel de votação da sessão para arquivo.</Typography>
                ]
            },

            {
                icone: <Difference style={{ cursor: 'pointer', width: '22px', height: '22px' }} />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Relatório de comparação de dados cadastrais e da decisão da certidão com as informações do
                        voto/acórdão.
                    </Typography>
                ]
            },

            {
                icone: <IconeLimpar />,
                descricao: [<Typography key={this.nextKey}>Limpar todos os filtros ativos.</Typography>]
            },
            {
                icone: (
                    <Avatar style={{ width: '30px', height: '30px' }}>
                        <FilterList
                            color={'primary'}
                            style={{ width: '24px', height: '24px' }}
                        />
                    </Avatar>
                ),
                descricao: [<Typography key={this.nextKey}>Viabiliza acesso a filtros pré-definidos.</Typography>]
            },
            {
                icone: <SegredoJustica />,
                descricao: [
                    <Typography key={this.nextKey}>Processo possui indicação de segredo de justiça.</Typography>
                ]
            },
            {
                icone: <SustentacaoOral />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Indica que no processo há pedido de inscrição de advogado:
                    </Typography>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <SustentacaoOral />
                        <Add style={{ width: '13px', height: '13px', marginRight: '24px', marginBottom: '11px' }} />
                        <Typography>
                            Há mais de um pedido de participação em sessão (preferência / sustentação oral) para o
                            processo;
                        </Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <SustentacaoOral style={{ fill: green[900], fillOpacity: '0.7', marginRight: '33px' }} />
                        <Typography>Advogado presente;</Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <SustentacaoOral style={{ fill: red[900], fillOpacity: '0.7', marginRight: '33px' }} />
                        <Typography>Advogado ausente;</Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <SustentacaoOral style={{ fill: yellow[900], fillOpacity: '0.7' }} />
                        <Add
                            style={{
                                fill: yellow[900],
                                width: '13px',
                                height: '13px',
                                marginRight: '24px',
                                marginBottom: '11px'
                            }}
                        />
                        <Typography>
                            Advogado presente em alguns processos e ausente (ou sem informação de presença) em outros
                            processos.
                        </Typography>
                    </Box>
                ]
            },
            {
                icone: <IconeAdvogadoPreferencia />,
                descricao: [
                    <Typography key={this.nextKey}>Indica que o processo teve um pedido de preferência.</Typography>
                ]
            },
            {
                icone: (
                    <Box style={{ width: '24px' }}>
                        <IconeAdvogadoParticipacaoVirtual />
                    </Box>
                ),
                descricao: [
                    <Typography key={this.nextKey}>
                        Indica que o processo teve um pedido de participação virtual.
                    </Typography>
                ]
            },
            {
                icone: (
                    <Box style={{ width: '24px' }}>
                        <IconeAdvogadoSustentacaoOralEletronica />
                    </Box>
                ),
                descricao: [
                    <Typography key={this.nextKey}>
                        Indica que o processo teve um pedido de sustentação oral eletrônica.
                    </Typography>
                ]
            },
            {
                icone: (
                    <Box style={{ width: '24px' }}>
                        <IconeAdvogadoPedidoDestaque />
                    </Box>
                ),
                descricao: [
                    <Typography key={this.nextKey}>Indica que o processo teve um pedido de destaque:</Typography>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <BookmarkAddIcon style={{ fill: green[900], marginRight: '24px', fillOpacity: '0.7' }} />
                        <Typography>Pedido de destaque deferido;</Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <BookmarkAddIcon style={{ fill: red[900], marginRight: '24px', fillOpacity: '0.7' }} />
                        <Typography>Pedido de destaque indeferido;</Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <BookmarkAddIcon style={{ fill: grey[500], marginRight: '24px', fillOpacity: '0.7' }} />
                        <Typography>Pedido de destaque não analisado;</Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <BookmarkAddIcon style={{ fill: 'black', marginRight: '24px' }} />
                        <Typography>Pedido de destaque sem informação;</Typography>
                    </Box>
                ]
            },
            {
                icone: <IconeAdvogadoSustentacaoOralTelepresencial />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Indica que o processo teve um pedido de participação por videoconferência.
                    </Typography>
                ]
            },
            {
                icone: (
                    <Box style={{ width: '24px', fontSize: '24px' }}>
                        <IconeAdvogado />
                    </Box>
                ),
                descricao: [
                    <Typography key={this.nextKey}>
                        Indica que o processo teve um pedido de participação indefinido.
                    </Typography>
                ]
            },
            {
                icone: <Anotacoes />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Há anotações no processo, realizadas no respectivo campo logo abaixo do painel de informações do
                        processo.
                    </Typography>
                ]
            },
            {
                icone: <VistaMesa />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Na listagem de processos, indica que há pedido de vista em mesa no processo. Nesse caso, ao
                        clicar no ícone há possibilidade de excluir a vista.
                    </Typography>,
                    <Typography key={this.nextKey}>
                        No painel de informações do processo, o acionamento do ícone possibilita a inclusão de vista em
                        mesa.
                    </Typography>
                ]
            },
            {
                icone: <VistaRegimental />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Indica que o processo está retornando de vista regimental.
                    </Typography>
                ]
            },
            {
                icone: <Restore />,
                descricao: [
                    <Typography key={this.nextKey}>Indica que o processo está retornando de adiamento.</Typography>
                ]
            },
            {
                icone: (
                    <Typography
                        component="span"
                        style={{ display: 'flex' }}
                    >
                        <Impedimento />
                        <Typography
                            display={'inline'}
                            sx={{ ml: 1, mr: 1 }}
                        >
                            ou
                        </Typography>
                        <ThumbDown style={{ transform: 'scaleX(-1)' }} />
                    </Typography>
                ),
                descricao: [
                    <Typography key={this.nextKey}>
                        Indicam que o processo possui impedimento de algum magistrado. Ao clicar nos ícones o sistema
                        exibirá quais magistrados estão impedidos.
                    </Typography>,
                    <Typography key={this.nextKey}>
                        O ícone apresenta as cores abaixo relacionadas conforme regras descritas:
                    </Typography>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        {SituacaoImpedimentosProcesso.getIcone(
                            SITUACAO_IMPEDIMENTOS_PROCESSO.IMPEDIMENTO_DECLARADO_FORA_DA_COMPOSICAO.id,
                            '24px'
                        )}
                        <Typography sx={{ ml: 3 }}>
                            Há impedimento declarado cujo magistrado não está na composição do processo;
                        </Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        {SituacaoImpedimentosProcesso.getIcone(
                            SITUACAO_IMPEDIMENTOS_PROCESSO.IMPEDIMENTO_DECLARADO_NA_COMPOSICAO.id,
                            '24px'
                        )}
                        <Typography sx={{ ml: 3 }}>
                            Há impedimento declarado cujo magistrado está na composição do processo;
                        </Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        {SituacaoImpedimentosProcesso.getIcone(
                            SITUACAO_IMPEDIMENTOS_PROCESSO.POSSIVEL_IMPEDIMENTO_FORA_DA_COMPOSICAO.id,
                            '24px'
                        )}
                        <Typography sx={{ ml: 3 }}>
                            Há possível impedimento de magistrado que não está na composição do processo;
                        </Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        {SituacaoImpedimentosProcesso.getIcone(
                            SITUACAO_IMPEDIMENTOS_PROCESSO.POSSIVEL_IMPEDIMENTO_NA_COMPOSICAO.id,
                            '24px'
                        )}
                        <Typography sx={{ ml: 3 }}>
                            Há possível impedimento de magistrado que está na composição do processo.
                        </Typography>
                    </Box>
                ]
            },
            {
                icone: <PeticoesPendentes />,
                descricao: [
                    <Typography key={this.nextKey}>Indica quantas petições pendentes há no processo.</Typography>
                ]
            },
            {
                icone: <Star />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Indica que há destaque no processo. Ao clicar no ícone serão exibidos os detalhes dos destaques.
                    </Typography>
                ]
            },
            {
                icone: (
                    <IconeTipoJulgamento
                        tipoJulgamento={MEIO_JULGAMENTO_PROCESSO.PRESENCIAL.codigo}
                        apenasIcone
                    />
                ),
                descricao: [<Typography key={this.nextKey}>Processo em julgamento presencial.</Typography>]
            },
            {
                icone: (
                    <IconeTipoJulgamento
                        tipoJulgamento={MEIO_JULGAMENTO_PROCESSO.VIRTUAL.codigo}
                        apenasIcone
                    />
                ),
                descricao: [<Typography key={this.nextKey}>Processo em julgamento virtual.</Typography>]
            },
            {
                icone: (
                    <IconeTipoJulgamento
                        tipoJulgamento={MEIO_JULGAMENTO_PROCESSO.REMETIDO_PARA_SESSAO_VINCULADA.codigo}
                        apenasIcone
                    />
                ),
                descricao: [
                    <Typography key={this.nextKey}>
                        Processo remetido para julgamento em sala de sessão (presencial ou telepresencial) vinculado ao
                        julgamento virtual.
                    </Typography>
                ]
            },
            {
                icone: (
                    <IconeTipoJulgamento
                        tipoJulgamento={MEIO_JULGAMENTO_PROCESSO.VIRTUAL_REMETIDO.codigo}
                        apenasIcone
                    />
                ),
                descricao: [
                    <Typography key={this.nextKey}>
                        Processo inicialmente destinado à julgamento virtual, mas que foi remetido para sessão futura.
                    </Typography>
                ]
            },
            {
                icone: TipoRemessaJulgamentoProcesso.getIcone(),
                descricao: [
                    <Typography key={this.nextKey}>Indica o tipo de remessa de julgamento do processo:</Typography>
                ].concat(this.carregarItensRemessaJulgamento())
            },
            {
                icone: <CorreJunto />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Indica que o processo tem um ou mais processos corre junto. Ao clicar no ícone o sistema exibirá
                        os processos.
                    </Typography>
                ]
            },
            {
                icone: <NaoLiberado />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Indica que a minuta de voto ainda não foi liberada pelo relator.
                    </Typography>
                ]
            },
            {
                icone: (
                    <Typography
                        component="span"
                        style={{ display: 'flex' }}
                    >
                        <StatusMinuta apenasIcone />
                        <Typography
                            display={'inline'}
                            sx={{ ml: 1, mr: 1 }}
                        >
                            ou
                        </Typography>
                        <StatusMinuta
                            apenasIcone
                            analisado
                        />
                    </Typography>
                ),
                descricao: [
                    <Typography key={this.nextKey}>Indica a situação da minuta de voto:</Typography>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <StatusMinuta
                            apenasIcone
                            id={SITUACAO_ALTERACAO_MINUTA.ALTERADA.id}
                        />
                        <Typography
                            display="inline"
                            sx={{ ml: 3 }}
                        >
                            {SITUACAO_ALTERACAO_MINUTA.ALTERADA.descricao};
                        </Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <StatusMinuta
                            apenasIcone
                            analisado
                            id={SITUACAO_ALTERACAO_MINUTA.ALTERACAO_ANALISADA.id}
                        />
                        <Typography
                            display="inline"
                            sx={{ ml: 3 }}
                        >
                            {SITUACAO_ALTERACAO_MINUTA.ALTERACAO_ANALISADA.descricao};
                        </Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <StatusMinuta
                            apenasIcone
                            id={SITUACAO_ALTERACAO_MINUTA.EMENTA_EOU_DECISAO_ALTERADAS.id}
                        />
                        <Typography
                            display="inline"
                            sx={{ ml: 3 }}
                        >
                            {SITUACAO_ALTERACAO_MINUTA.EMENTA_EOU_DECISAO_ALTERADAS.descricao};
                        </Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <StatusMinuta
                            apenasIcone
                            analisado
                            id={SITUACAO_ALTERACAO_MINUTA.ALTERACAO_EMENTA_EOU_DECISAO_ANALISADAS.id}
                        />
                        <Typography
                            display="inline"
                            sx={{ ml: 3 }}
                        >
                            {SITUACAO_ALTERACAO_MINUTA.ALTERACAO_EMENTA_EOU_DECISAO_ANALISADAS.descricao}.
                        </Typography>
                    </Box>
                ]
            },
            {
                icone: <IconeVotoRevogado sx={{ fill: 'black', fillOpacity: '1' }} />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Indica que há votações revogadas, decorrente de alteração(ões) na minuta após a liberação pelo
                        relator.
                    </Typography>
                ]
            },
            {
                icone: <PublishedWithChanges sx={{ fill: 'black', fillOpacity: '1' }} />,
                descricao: [
                    <Typography key={this.nextKey}>Indica a opção para republicar os processos da pauta.</Typography>
                ]
            },
            {
                icone: <Unpublished sx={{ fill: 'black', fillOpacity: '1' }} />,
                descricao: [
                    <Typography key={this.nextKey}>Cancela a disponibilização em diário de processos.</Typography>
                ]
            },
            {
                icone: <Gavel />,
                descricao: [
                    <Typography key={this.nextKey}>Indica o resultado da apreciação do processo:</Typography>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <Gavel style={{ fill: green[900], fillOpacity: '0.7', marginRight: '24px' }} />
                        <Typography>Processo julgado;</Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <Gavel style={{ fill: yellow[900], fillOpacity: '0.7', marginRight: '24px' }} />
                        <Typography>Processo julgado com alteração de voto ou observação;</Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <Gavel style={{ fill: red[900], fillOpacity: '0.7', marginRight: '24px' }} />
                        <Typography>Processo foi apreciado com uma das opções &qutot;Não julgado&qutot;.</Typography>
                    </Box>
                ]
            },
            {
                icone: <Announcement />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Indica que há voto com ressalva. Ao clicar no ícone o sistema exibe as observações de ressalvas
                        de votos confirmados.
                    </Typography>
                ]
            },
            {
                icone: <ForkRight style={{ transform: 'rotate(90deg)' }} />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Indica que há divergência na votação. Ao clicar no ícone o sistema exibe as observações de
                        divergências de votos confirmados.
                    </Typography>
                ]
            },
            {
                icone: <IconeAcordao />,
                descricao: [
                    <Typography key={this.nextKey}>Indica a situação do acórdão:</Typography>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <IconeAcordao
                            style={{
                                fill: SITUACAO_ACORDAO.NAO_PUBLICAVEL.cor,
                                fillOpacity: '0.7',
                                marginRight: '24px'
                            }}
                        />
                        <Typography>{SITUACAO_ACORDAO.NAO_PUBLICAVEL.descricao};</Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <IconeAcordao
                            style={{ fill: SITUACAO_ACORDAO.NAO_ASSINADO.cor, fillOpacity: '0.7', marginRight: '24px' }}
                        />
                        <Typography>{SITUACAO_ACORDAO.NAO_ASSINADO.descricao};</Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <IconeAcordao
                            style={{
                                fill: SITUACAO_ACORDAO.ASSINADO_ORIGEM.cor,
                                fillOpacity: '0.7',
                                marginRight: '24px'
                            }}
                        />
                        <Typography>{SITUACAO_ACORDAO.ASSINADO_ORIGEM.descricao};</Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <IconeAcordao
                            style={{
                                fill: SITUACAO_ACORDAO.ASSINADO_E_NAO_VERIFICADO.cor,
                                fillOpacity: '0.7',
                                marginRight: '24px'
                            }}
                        />
                        <Typography>{SITUACAO_ACORDAO.ASSINADO_E_NAO_VERIFICADO.descricao};</Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <IconeAcordao
                            style={{
                                fill: SITUACAO_ACORDAO.DEVOLVIDO_PARA_CORRECAO.cor,
                                fillOpacity: '0.7',
                                marginRight: '24px'
                            }}
                        />
                        <Typography>{SITUACAO_ACORDAO.DEVOLVIDO_PARA_CORRECAO.descricao};</Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <IconeAcordao
                            style={{
                                fill: SITUACAO_ACORDAO.ASSINADO_E_VERIFICADO.cor,
                                fillOpacity: '0.7',
                                marginRight: '24px'
                            }}
                        />
                        <Typography>{SITUACAO_ACORDAO.ASSINADO_E_VERIFICADO.descricao}.</Typography>
                    </Box>
                ]
            },
            {
                icone: (
                    <FontAwesomeIcon
                        icon={faAngleDoubleRight}
                        style={{ width: '24px', height: '24px' }}
                    />
                ),
                descricao: [
                    <Typography key={this.nextKey}>
                        No painel de informações do processo, aba Decisão, indica que o Movimento CNJ cadastrado para o
                        processo do PJe possui um ou mais complementos:
                    </Typography>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <FontAwesomeIcon
                            icon={faAngleDoubleRight}
                            style={{ width: '24px', height: '24px', marginRight: '24px' }}
                            color={lightGreen[900]}
                        />
                        <Typography>
                            {'Indica que os complementos estão preenchidos. Caso haja complementos excludentes (separados por uma barra ' +
                                'na descrição do movimento), o sistema indica que um dos complementos está preenchido;'}
                        </Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <FontAwesomeIcon
                            icon={faAngleDoubleRight}
                            style={{ width: '24px', height: '24px', marginRight: '24px' }}
                            color={orange[900]}
                        />
                        <Typography>{'Sinaliza que há complementos sem preenchimento.'}</Typography>
                    </Box>
                ]
            },
            {
                icone: (
                    <img
                        src={IconeJulgar}
                        alt="Julgar"
                    />
                ),
                descricao: [<Typography key={this.nextKey}>Julgar processo.</Typography>]
            },
            {
                icone: (
                    <img
                        src={IconeJulgarAlterado}
                        alt="Julgar com alteração de voto"
                    />
                ),
                descricao: [<Typography key={this.nextKey}>Julgar processo indicando alteração no voto.</Typography>]
            },
            {
                icone: (
                    <img
                        src={IconeJulgarObervacao}
                        alt="Julgar com observação"
                    />
                ),
                descricao: [<Typography key={this.nextKey}>Julgar processo com observação.</Typography>]
            },
            {
                icone: (
                    <img
                        src={IconeNaoJulgado}
                        alt="Apreciar processo como não julgado"
                    />
                ),
                descricao: [
                    <Typography key={this.nextKey}>
                        Apreciar processo como não julgado. Será necessário escolher uma das situações de apreciação que
                        irão aparecer na janela.
                    </Typography>
                ]
            },
            {
                icone: <Assignment />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Abrir a janela que permite editar a certidão do processo.
                    </Typography>
                ]
            },
            {
                icone: <SimCardAlert style={{ color: 'darkorange' }} />,
                descricao: [
                    <Typography key={this.nextKey}>Processo sem informação para intimar todas as partes.</Typography>
                ]
            },
            {
                icone: <PlaylistAddCheck />,
                descricao: [<Typography key={this.nextKey}>Processo confirmado para inclusão em pauta.</Typography>]
            },
            {
                icone: <Publish />,
                descricao: [
                    <Typography key={this.nextKey}>Indica a situação da publicação do processo:</Typography>
                ].concat(this.carregarItensSituacaoPublicacaoPauta())
            },
            {
                icone: <TaskIcon />,
                descricao: [
                    <Typography key={this.nextKey}>Indica a situação da análise do processo:</Typography>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <Cancel sx={{ fill: SITUACAO_ANALISE.SEM_VALIDACAO.cor, fillOpacity: '0.7', mr: 3 }} />
                        <Typography>Sem validação;</Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <CheckCircleRounded sx={{ fill: SITUACAO_ANALISE.VALIDADO.cor, fillOpacity: '0.7', mr: 3 }} />
                        <Typography>Validado;</Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <Cancel sx={{ fill: SITUACAO_ANALISE.PENDENTE.cor, fillOpacity: '0.7', mr: 3 }} />
                        <Typography>Pendente.</Typography>
                    </Box>
                ]
            },
            {
                icone: <Sensors />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Indica a situação da atualização automática de informações dos processos na Pré-Sessão:
                    </Typography>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <Sensors
                            color="primary"
                            sx={{ mr: 3 }}
                        />
                        <Typography>Atualização habilitada.</Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <SensorsOff
                            color="disabled"
                            sx={{ mr: 3 }}
                        />
                        <Typography>
                            Atualização desabilitada e <strong>sem</strong> novas atualizações disponíveis.
                        </Typography>
                    </Box>,
                    <Box
                        key={this.nextKey}
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <SensorsOff
                            color="warning"
                            sx={{ mr: 3 }}
                        />
                        <Typography>
                            Atualização desabilitada e <strong>com</strong> novas atualizações disponíveis.
                        </Typography>
                    </Box>
                ]
            },
            {
                icone: <OrdemPreSessao ordem={1} />,
                descricao: [
                    <Typography key={this.nextKey}>
                        Indica a ordem do processo na listagem de processos da pré-sessão.
                    </Typography>
                ],
                estilosConteudo: { pt: 0.5 }
            },
            {
                icone: (
                    <OrdemPreSessao
                        ordem={1}
                        total={10}
                    />
                ),
                descricao: [
                    <Typography key={this.nextKey}>
                        Indica a ordem do processo / total de processos na listagem da pré-sessão.
                    </Typography>
                ],
                estilosIcone: { mr: 2 },
                estilosConteudo: { pt: 0.5 }
            }
        ];
        return (
            <Box
                id="info-ajuda"
                style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '6px' }}
            >
                <IconButton
                    onClick={this.abrirInfo}
                    color="inherit"
                    aria-label="Ajuda"
                    style={{ width: '40px' }}
                    size="large"
                >
                    <Tooltip title={'Ajuda'}>
                        <Help />
                    </Tooltip>
                </IconButton>
                {this.open && (
                    <Dialog
                        open={this.open}
                        onClose={this.fecharInfo}
                        maxWidth="lg"
                    >
                        <Typography
                            component="h1"
                            variant="h4"
                            style={{ margin: '24px 24px 0px 24px' }}
                        >
                            Ajuda
                        </Typography>
                        <Box style={{ display: 'flex', flexDirection: 'column', padding: '16px 24px' }}>
                            <Typography
                                component="h2"
                                variant="h5"
                            >
                                Ordenação dos processos:
                            </Typography>
                            <Typography component="p">
                                Processos pendentes são ordenados conforme os critérios abaixo:
                            </Typography>
                            {this.parametroStore.isOrgaoTST ? (
                                <ol>
                                    <li>
                                        <Typography>vista em mesa;</Typography>
                                    </li>
                                    <li>
                                        <Typography>ordenação do secretario;</Typography>
                                    </li>
                                    <li>
                                        <Typography>sequencial;</Typography>
                                    </li>
                                    <li>
                                        <Typography>pedido de inscrição de advogado;</Typography>
                                    </li>
                                    <li>
                                        <Typography>pedido de preferência;</Typography>
                                    </li>
                                    <li>
                                        <Typography>classe de processo HC;</Typography>
                                    </li>
                                    <li>
                                        <Typography>anotação curta do secretário;</Typography>
                                    </li>
                                    <li>
                                        <Typography>anotação do secretário;</Typography>
                                    </li>
                                    <li>
                                        <Typography>vista regimental;</Typography>
                                    </li>
                                    <li>
                                        <Typography>voto divergente;</Typography>
                                    </li>
                                    <li>
                                        <Typography>destaque;</Typography>
                                    </li>
                                    <li>
                                        <Typography>ressalvas;</Typography>
                                    </li>
                                    <li>
                                        <Typography>minutas alteradas;</Typography>
                                    </li>
                                    <li>
                                        <Typography>processos remanescentes;</Typography>
                                    </li>
                                    <li>
                                        <Typography>antiguidade dos ministros relatores;</Typography>
                                    </li>
                                    <li>
                                        <Typography>classe do processo;</Typography>
                                    </li>
                                    <li>
                                        <Typography>número do processo.</Typography>
                                    </li>
                                </ol>
                            ) : (
                                <ul>
                                    <li>
                                        <Typography>vista;</Typography>
                                    </li>
                                    <li>
                                        <Typography>sustentação oral;</Typography>
                                    </li>
                                    <li>
                                        <Typography>sequencial de preferência;</Typography>
                                    </li>
                                    <li>
                                        <Typography>número pauta;</Typography>
                                    </li>
                                </ul>
                            )}
                            <Typography
                                component="h2"
                                variant="h5"
                            >
                                Atalhos de teclado (Sala Sessão, Pauta de Julgamento e Pré-Sessão)
                            </Typography>
                            <ul>
                                <li style={{ marginBottom: '8px' }}>
                                    <Typography>Ctrl + &#9660;: Abre o próximo processo;</Typography>
                                </li>
                                <li style={{ marginBottom: '8px' }}>
                                    <Typography>Ctrl + &#9650;: Abre o processo anterior;</Typography>
                                </li>
                                <li style={{ marginBottom: '8px' }}>
                                    <Typography>
                                        Ctrl + &#9664;: Exibe a lista de processos da aba PENDENTES;
                                    </Typography>
                                </li>
                                <li style={{ marginBottom: '8px' }}>
                                    <Typography>
                                        Ctrl + &#9654;: Exibe a lista de processos da aba APRECIADOS;
                                    </Typography>
                                </li>
                                <li style={{ marginBottom: '8px' }}>
                                    <Typography>Ctrl + Shift + F: Entra na barra de pesquisa de processos;</Typography>
                                </li>
                                <li style={{ marginBottom: '8px' }}>
                                    <Typography>
                                        Ctrl + Alt + Home: Abre o primeiro processo na lista de processos;
                                    </Typography>
                                </li>
                                <li style={{ marginBottom: '8px' }}>
                                    <Typography>
                                        Ctrl + Alt + End: Abre o último processo na lista de processos;
                                    </Typography>
                                </li>
                                <li style={{ marginBottom: '8px' }}>
                                    <Typography>
                                        Ctrl + Alt + Page Down: Move a lista de processos para baixo;
                                    </Typography>
                                </li>
                                <li style={{ marginBottom: '8px' }}>
                                    <Typography>Ctrl + Alt + Page Up: Move a lista de processos para cima;</Typography>
                                </li>
                                <li>
                                    <Typography>Ctrl + \: Abre ou fecha painel de listagem dos processos.</Typography>
                                </li>
                            </ul>
                            <Typography
                                component="h2"
                                variant="h5"
                            >
                                Ícones
                            </Typography>
                            <List>
                                {listaIcones.map((objIcone) => {
                                    const estilosIcone = objIcone.estilosIcone ? objIcone.estilosIcone : { mr: 3 };
                                    const estilosConteudo = objIcone.estilosConteudo ? objIcone.estilosConteudo : {};
                                    return (
                                        (objIcone.habilitado === undefined || objIcone.habilitado) && (
                                            <ListItem
                                                key={this.nextKey}
                                                sx={{ display: 'flex', alignItems: 'flex-start' }}
                                            >
                                                <Box
                                                    key={this.nextKey}
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        ...estilosIcone
                                                    }}
                                                >
                                                    {objIcone.icone}
                                                </Box>
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        ...estilosConteudo
                                                    }}
                                                >
                                                    {objIcone.descricao.map((descricao) => (
                                                        <Typography
                                                            key={this.nextKey}
                                                            style={{ textAlign: 'justify' }}
                                                        >
                                                            {descricao}
                                                        </Typography>
                                                    ))}
                                                </Box>
                                            </ListItem>
                                        )
                                    );
                                })}
                            </List>
                            <Typography
                                component="p"
                                sx={{ m: 3, textAlign: 'justify', fontSize: '0.8rem' }}
                            >
                                Todos os ícones da Secretaria Eletrônica estão sob as licenças livres&nbsp;
                                <a href="https://www.apache.org/licenses/LICENSE-2.0.html">Apache versão 2.0</a> e&nbsp;
                                <a href="https://opensource.org/licenses/mit-license.php">MIT</a>, podendo ser
                                encontrados nos sites oficiais de ícones do&nbsp;
                                <a href="https://material.io/tools/icons/?style=baseline">Material-ui</a> e&nbsp;
                                <a href="https://fontawesome.com/icons?d=gallery">Fontawesome</a>.
                            </Typography>
                        </Box>
                    </Dialog>
                )}
            </Box>
        );
    }
}

export default inject('stores')(observer(Legenda));
